const setDoc = (doc) => {
	if (doc) {
		setDocId(doc);
		setName(doc);
	} else {
		return null;
	}
};

const setDocById = (id) => {
	if (id) {
		const doc = findDoc(id);
		setDoc(doc);
	}
};

const setName = (doc) => {
	if (doc) {
		const name = formatName(doc);
		$('#business-data').attr('data-doctor-name', name);
	}
};

const setDocId = (doc) => {
	if (doc && doc._id) {
		$('#business-data').attr('data-doctor-id', doc._id);
		if (window.PB) {
			window.PB.doc = doc;
		}
	}
}

const findDoc = (id) => {
	if (window.PB && window.PB.staff.length > 0) {
		return window.PB.staff.find(s => s._id === id);
	} else {
		return null;
	}
}

const clearDoc = () => {
	window.PB.doc = null;
}

const getDocName = (id) => {
	const doc = findDoc(id);
	if (doc) {
		return formatName(doc);
	}
	return '';
}

const formatName = (doc) => {
	if (doc) {
		return `${doc.salutation} ${doc.first_name} ${doc.last_name}`;
	} else {
		return '';
	}
}

const getUniqueAppTimes = (appArray) => {
	return appArray.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj['start_time']).indexOf(obj['start_time']) === pos;
  })
};

const getAppsforCurrentDoc = () => {
	if (!window.PB.appointments) {
		return [];
	}

	let currentArray = [];
	if (!window.PB.doc) {
		currentArray = window.PB.appointments.map(dayArray => ({
			...dayArray,
			aptsArr: getUniqueAppTimes(dayArray.aptsArr),
		}));
	} else {
		currentArray = window.PB.appointments.map(dayArray => ({
			...dayArray,
			aptsArr: dayArray.aptsArr.filter(app => app.doctor_id === window.PB.doc._id),
		})).filter((day => day.aptsArr.length > 0));
	}

	currentArray.forEach((ca) => {
		const appNumber = ca.aptsArr.length;
		ca.title = appNumber > 9 ? '9+' : appNumber.toString();
	});
	return currentArray;
}

export {
	setDoc, setDocById,
	findDoc, getAppsforCurrentDoc, getDocName, clearDoc,
	getUniqueAppTimes,
};



// WEBPACK FOOTER //
// ./public/src/doctorMethods.js